import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-enterprise';

@Component({
  selector: 'image-header-renderer',
  templateUrl: 'image-header-renderer.component.html',
  styleUrls: ['./image-header-renderer.component.scss'],
})
export class ImageHeaderRendererComponent implements IHeaderAngularComp {

  params!: IHeaderParams;
  iconSrc: string = '';
  imageTitle: string = '';
  sortDirection: 'asc' | 'desc' | null = null;

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.setParameters();
    params.column.addEventListener('sortChanged', this.onSortChanged.bind(this));
    this.onSortChanged();
  }

  private setParameters(): void {
    const p = this.params as any;
    const filename: string = p.rendererImageFilename ?? '';
    this.iconSrc = filename ? 'assets/sprites/sprite.svg#' + filename.replace('.svg', '') : '';
    this.imageTitle = p.imageTitle ?? this.params.displayName;
  }

  onSortChanged(): void {
    this.sortDirection = this.params.column.getSort() ?? null;
  }

  onSortRequested(event: MouseEvent): void {
    this.params.progressSort(event.shiftKey);
  }

  refresh(params: IHeaderParams): boolean {
    this.params = params;
    this.setParameters();
    return true;
  }
}
